import { GET_AORTA_GO_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TGetProfilesPatientResponse } from "../types/aorta-go";
import { GET_EXTRA_HEADERS } from "apis/src/constants/env";

export interface PatientFormData {
    label: string;
    type: 'number' | 'string' | 'select';
    key: string;
    value: string | number;
}

export interface AuthgoPatient {
    oid: string;
    wid: string;
    ps?: string;
    c_ate: number; // in seconds since epoch
    u_ate: number; // in seconds since epoch
    gen: string;
    dob: string; // in YYYY-MM-DD
    fn: string;
    ln?: string;
    mn?: string;
    fln: string;
    arc?: boolean;
    _custom_uuid?: string;
    uuid?: string;
    mobile?: string;
    extras?: {
        formData?: PatientFormData[];
        link?: string[];
        payments?:
            | number
            | {
                  dues: number;
              };
        refer_id?: string;
    };
    at: string;
    uat: string;
    abha?: string;
    username?: string;
    s?: string;
}

export default async function getPatientData(oid: string): Promise<AuthgoPatient> {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
  };

  if (!oid) return {} as AuthgoPatient;

  try {
    const AORTA_GO_HOST = GET_AORTA_GO_HOST();
    const response = await fetch(
      `${AORTA_GO_HOST}/profiles/v1/patient/${oid}`,
      requestOptions
    );

    return await response.json();
  } catch (error) {
    console.error("profilePhrUser error =>", error);
    return {} as AuthgoPatient;
  }
}